export * from './keyPairs.read.service';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/amazon/src/keyPairs/index.ts